import { render } from "./NewPrintTemplate.vue?vue&type=template&id=1e838b44&scoped=true"
import script from "./NewPrintTemplate.vue?vue&type=script&lang=js"
export * from "./NewPrintTemplate.vue?vue&type=script&lang=js"

import "./NewPrintTemplate.vue?vue&type=style&index=0&id=1e838b44&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e838b44"]])

export default __exports__